// NOTE font sizes: the header setting "font size" (workorder-font-size-setting-2026-09-14) multiplies the
// component pixel sizes with the CSS custom properties --whoo-fs-title|subtitle|details|text. A theme that
// sets a `font-size` here overrides that calc() via ngStyle - write it as
// `'font-size': 'calc(Xpx * var(--whoo-fs-<group>, 1))'` so the setting keeps working for that theme.
export type GenericStyleConfig = {
    voteStyle?: {
        bigScreen?: GenericVoteStyleConfig,
        smallScreen?: GenericVoteStyleConfig
    }
}

export interface GenericVoteStyleConfig {
    headerBlur?: any;
    backgroundContainer?: any;
    background?: any;
    headerContainer?: any;
    title?: any;
    subtitle?: any;
    date?: any;
    time?: any;
    whereBox?: any;
    whereTitle?: any;
    respondTillTitle?: any;
    respondTillDate?: any;
    formContainer?: any;
    formTitle?: any;
}
export const genericStyleMap = new Map<string, GenericStyleConfig>([

    ['no-background', {
        voteStyle: {
            bigScreen: {
                headerContainer: {
                    'min-height': '0px'
                },

                headerBlur: {
                    'box-shadow': 'none',
                },
            },
            smallScreen: {
                headerContainer: {
                    'min-height': '0px'
                },
                headerBlur: {
                    'box-shadow': 'none',
                },
            }
        }
    }],
    ['default', {
        voteStyle: {
            bigScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 300px rgba(27, 33, 38, 0.3)',
                },
            },
            smallScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 220px rgba(27, 33, 38, 0.6)',
                },
            }
        }

    }]
    , ['dark-shadow-medium', {
        voteStyle: {
            bigScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 300px rgba(27, 33, 38, 0.5)',
                },
            },
            smallScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 220px rgba(27, 33, 38, 0.8)',
                },
            }
        }
    }],
    ['dark-shadow-strong', {
        voteStyle: {
            bigScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 300px rgba(27, 33, 38, 0.7)',
                },
            },
            smallScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 220px rgba(27, 33, 38, 0.9)',
                },
            }
        }
    }],
    ['light-shadow', {
        voteStyle: {
            bigScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 300px rgba(255, 255, 255, 0.3)',
                },
            },
            smallScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 220px rgba(255, 255, 255, 0.6)',
                },
            }
        }
    }],
    ['light-shadow-medium', {
        voteStyle: {
            bigScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 300px rgba(255, 255, 255, 0.5)',
                },
            },
            smallScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 220px rgba(255, 255, 255, 0.8)',
                },
            }
        }
    }],
    ['light-shadow-strong', {
        voteStyle: {
            bigScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 300px rgba(255, 255, 255, 0.7)',
                },
            },
            smallScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 220px rgba(255, 255, 255, 0.9)',
                },
            }
        }
    }],
    ['warm-shadow', {
        voteStyle: {
            bigScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 300px rgba(245, 235, 220, 0.4)',
                },
            },
            smallScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 220px rgba(245, 235, 220, 0.7)',
                },
            }
        }
    }],
    ['blue-shadow', {
        voteStyle: {
            bigScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 300px rgba(0, 123, 255, 0.3)',
                },
            },
            smallScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 220px rgba(0, 123, 255, 0.6)',
                },
            }
        }
    }],
    ['red-shadow', {
        voteStyle: {
            bigScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 300px rgba(220, 53, 69, 0.3)',
                },
            },
            smallScreen: {
                headerBlur: {
                    'box-shadow': '0px -0px 120px 220px rgba(220, 53, 69, 0.6)',
                },
            }
        }
    }],
    ['tile-background', {
        voteStyle: {
            bigScreen: {
                background: {
                    'background-repeat': 'repeat',
                    'background-size': 'auto',
                    'background-position': 'center',
                },
            },
            smallScreen: {
                background: {
                    'background-repeat': 'repeat',
                    'background-size': 'auto',
                    'background-position': 'center',
                },
            }
        }
    }],
])

